import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { z } from 'zod'
import { zodI18nMap } from 'zod-i18n-map'
import translation from 'zod-i18n-map/locales/ja/zod.json'

i18n.use(initReactI18next).init({
  resources: {
    ja: {
      zod: translation,
      translation: {
        common: {
          id: 'Id',
          createdAt: '作成日時',
          updatedAt: '更新日時',
          actions: '設定',
        },
        theme: {
          mainColor: 'テーマカラー',
          mainTextColor: 'テキストカラー',
          bodyTextColor: 'テキストカラー（本文）',
        },
        account: {
          name: 'アカウント名',
        },
        accountConfig: {
          theme: {
            mainColor: '共通テーマカラー',
            mainTextColor: '共通テキストカラー',
          },
          allowOrigins: '許可URL',
        },
        survey: {
          name: 'アンケート名',
          description: '説明',
        },
        thanksContent: {
          name: 'サンクスページ名',
          configJson: {
            headingContent: 'タイトル',
            paragraphContent: '本文',
            presetImage: 'イメージ画像',
            imageLinkUrl: '画像に設定するリンク先URL',
            footerButtonContent: 'フッターボタン',
          },
        },
        campaign: {
          name: 'キャンペーン名',
          description: '説明',
          startAt: '開始日',
          endAt: '終了日',
          endCondition: '終了条件',
          enabled: '有効',
          survey: '配信アンケート',
          thanksContent: 'サンクスページ',
          tag: '集計タグ',
        },
        popup: {
          name: '管理用の名前',
          description: '説明',
          enabled: '有効',
          suspendSeconds: '閉じた後に再度配信するまでの時間(秒)',
          configJson: {
            displayPosition: 'ボタンの位置',
            horizontal: '横',
            vertical: '縦',
            showCloseButton: '閉じるボタンを表示',
            presetIcon: 'アイコン画像',
            title: 'タイトル',
            imageUrl: '画像',
            imageType: '画像タイプ',
            description: '本文',
          },
          campaigns: '配信キャンペーン',
          preview: 'プレビュー',
        },
        campaignSelectionContent: {
          configJson: {
            headingContent: 'タイトル',
            headingContentAlign: 'タイトルの整列',
            headingContentImageUrl: 'タイトル画像',
            paragraphContent: '本文',
          },
        },
        mypageSetting: {
          configJson: {
            headingContent: 'タイトル',
            tabs: {
              enabled: 'このタブを表示',
              tagId: '集計タグ',
              label: 'タブ名',
              url: 'コミュニティ投稿ボタンの表示',
              communityTalk: 'トークメニュー',
              communitySns: 'SNSメニュー',
            },
          },
        },
        tag: {
          name: 'タグ名',
        },
        tagStatisticsConfiguration: {
          configJson: {
            label: '集計ラベル',
            prefix: 'Prefix',
            suffix: 'Suffix',
          },
        },
        product: {
          name: '商品・店舗タグ名',
          description: '社内メモ',
        },
        productGroup: {
          name: '商品・店舗グループ名',
          description: '社内メモ',
        },
        productDashboard: {
          campaignName: 'キャンペーン',
          questionTitle: '質問',
          answer: '回答',
          answeredAt: '回答日',
        },
        answer: {
          user: 'ユーザ',
          campaign: 'キャンペーン',
          survey: 'アンケート',
          content: '回答内容',
        },
        user: {
          id: 'ユーザーID',
          memberId: 'メンバーID',
          name: '表示名',
          totalAnswerCount: '総記録数',
          firstAnswerDate: '初回記録日',
          latestAnswerDate: '最新記録日',
        },
        homeLauncher: {
          name: 'ホームランチャー名',
          displayCondition: '表示条件',
          configJson: {
            displayPosition: 'ボタンの位置',
            horizontal: '横',
            vertical: '縦',
          },
        },
        homeLauncherItem: {
          name: 'ボタン表示名',
          enabled: '表示',
        },
        componentDesign: {
          name: 'ホームランチャー名',
          componentType: 'コンポーネント種別',
          configJson: {
            buttonType: 'ボタン種別',
            designType: 'デザイン種別',
            title: 'テキスト',
            presetIcon: 'アイコン画像',
            imageUrl: '画像URL',
          },
        },
        receiptProduct: {
          userId: 'ユーザーID',
          memberId: 'メンバーID',
          userName: '表示名',
          item: 'レシート_商品名',
          price: 'レシート_金額',
          brand: 'レシート_ロゴ',
          store: 'レシート_店舗名',
          totalPrice: 'レシート_合計金額',
          purchasedAt: 'レシート_購入日',
          receiptImage: 'レシート画像',
          createdAt: '記録日',
          campaigns: '配信キャンペーン',
        },
        campaignAnswer: {
          userId: 'ユーザーID',
          memberId: 'メンバーID',
          userName: '表示名',
        },
        barcode: {
          userId: 'ユーザーID',
          memberId: 'メンバーID',
          userName: '表示名',
          janCode: 'JANコード',
          brand: 'ブランド名',
          product: '商品名',
          barcodeImage: 'バーコードの画像',
          createdAt: '記録日',
          campaigns: '配信キャンペーン',
        },
        gameStampRally: {
          name: 'スタンプラリー名',
          configJson: {
            type: '種別',
            headingContent: '表示するタイトル',
            columnCount: 'コレクションの最大収集数（横列）',
          },
          startAt: '開始日時（日本時間）',
          endAt: '終了日時（日本時間）',
          enabled: '公開設定',
        },
        gameCollectionCampaign: {
          campaigns: '表示するコレクション（縦列）',
        },
        featureFlag: {
          flagKey: 'フラグキー',
          config: {
            disabled: '利用・停止',
            variants: 'バリアント',
            defaultVariant: 'デフォルトバリアント',
          },
        },
        enum: {
          popup: {
            displayPosition: {
              'bottom-left': '左下',
              'bottom-right': '右下',
            },
            imageType: {
              titleBg: '帯背景',
              icon: 'アイキャッチ',
            },
            queryPresets: {
              all: '全て',
              delivery: '配信中(優先順位順)',
              deliveryScheduled: '配信中+配信予定(優先順位順)',
            },
          },
          thanksContent: {
            presetImage: {
              trophy: 'トロフィー',
              thumbsUp: 'サムズアップ',
              taskComplete: 'タスク完了',
              original: 'オリジナル',
            },
          },
          campaign: {
            endCondition: {
              none: 'なし',
              whenCompleted: 'アンケートの回答完了',
            },
            queryPresets: {
              all: '全て',
              delivery: '配信中(優先順位順)',
              deliveryScheduled: '配信中+配信予定(優先順位順)',
            },
          },
          homeLauncher: {
            displayCondition: {
              always: '常時表示',
              whenClosePopups: 'ポップアップclose時',
            },
          },
          componentDesign: {
            componentType: {
              button: 'ボタン',
            },
            designType: {
              template: 'テンプレートで作成',
              image: '画像アップロードで作成',
            },
          },
        },
        component: {
          textInput: {
            placeholder: '{{attribute}}を入力',
          },
          select: {
            placeholder: '{{attribute}}を選択',
          },
          search: {
            placeholder: '{{attribute}}で検索',
          },
          button: {
            save: '保存',
            add: '{{entity}}を追加',
            delete: '{{entity}}を削除',
            back: '戻る',
          },
          table: {
            sorting: {
              asc: '昇順',
              desc: '降順',
            },
            visibility: {
              filterTitle: '表示',
              toggleColumns: 'カラムの表示切替',
              hide: '非表示',
            },
          },
        },
      },
    },
  },
  fallbackLng: 'ja',
})

z.setErrorMap(zodI18nMap)

export {
  i18n,
}
